import Ship from "@/model/Ship"
import { NeobuqEconomicData, NeoEconomicDataPerYear} from "@/model/Neobuq/NeobuqModifications"

class NeobuqEconomicService{

    private static instance: NeobuqEconomicService;

    private constructor() {}

    public static getInstance(): NeobuqEconomicService {
        if (!NeobuqEconomicService.instance) {
            NeobuqEconomicService.instance = new NeobuqEconomicService();
        }

        return NeobuqEconomicService.instance;
    }

    public calc_economic_values(economicData : NeobuqEconomicData, financeOption : string){


        //usaremos una copia de la variable para trabajar con ella y evitar romper algo 
        const economicDataMod = {...economicData}
        //console.log(economicDataMod)

        //La cuota es una variable necesaria para los cálculos de los intereses del préstamo, que es fija para todos los años
        const cuota = 1 - Math.pow(1 + (economicDataMod.nominalInterest/100), economicDataMod.amortizationPeriod)
        //siempre se igualan al valor del año anterior al que estamos
        let capitalPendiente = 0
        let intereses = 0
        let amortizacion = 0
        //para el VAN
        let casilla = 0

        //vamos a realizar los cálculos para cada año
        for(let i=0; i<economicDataMod.dataPerYear.length; i++){

            //el indice 0 es el año 1; cuyos valores sí estan rellenados
            economicDataMod.dataPerYear[i].preModVariousCosts =  economicDataMod.dataPerYear[0].preModVariousCosts
            economicDataMod.dataPerYear[i].postModVariousCosts =  economicDataMod.dataPerYear[0].postModVariousCosts
            //1º Tenemos que cambiar el precio original del combustible (pre y post) según el % de incremento
            //Cogemos como referencia el combustible del año 1
            if(i!=0){
                //menos en el año 1, en el resto de años aplica el porcentaje
                const percentage = economicDataMod.annualFuelPriceIncrease / 100
                let lastYearPrice = 0

                for(let j=0; j<economicDataMod.dataPerYear[i].fuelsPreMod.length; j++ ){
                    //cogemos el precio el año anterior
                    lastYearPrice  =  economicDataMod.dataPerYear[i-1].fuelsPreMod[j].price
                    economicDataMod.dataPerYear[i].fuelsPreMod[j].price = Number((lastYearPrice * (1 + percentage)).toFixed(2))
                }

                lastYearPrice = 0
                //lo mismo para los precios DEPUÉS de la modificación
                for(let j=0; j<economicDataMod.dataPerYear[i].fuelsPostMod.length; j++ ){
                    //cogemos el precio el año anterior
                    lastYearPrice  =  economicDataMod.dataPerYear[i-1].fuelsPostMod[j].price
                    economicDataMod.dataPerYear[i].fuelsPostMod[j].price = Number((lastYearPrice * (1 + percentage)).toFixed(2))
                }
            }

            //2º Coste de combustible anual
            let annualFuelCost = 0
            //el número de combustibles es el mismo antes y después
            let preMod = 0
            let postMod = 0
            for(let j=0; j<economicDataMod.dataPerYear[i].fuelsPostMod.length; j++ ){
                preMod = economicDataMod.dataPerYear[i].fuelsPreMod[j].consumption * economicDataMod.dataPerYear[i].fuelsPreMod[j].price
                postMod = economicDataMod.dataPerYear[i].fuelsPostMod[j].consumption * economicDataMod.dataPerYear[i].fuelsPostMod[j].price
                const aux = preMod - postMod
                annualFuelCost = annualFuelCost + aux
            }
            economicDataMod.dataPerYear[i].annualFuelCost = Number(annualFuelCost.toFixed(2))

            //3º Variación de costes varios anual
            economicDataMod.dataPerYear[i].variationVariousCosts = Number((economicDataMod.dataPerYear[i].preModVariousCosts - economicDataMod.dataPerYear[i].postModVariousCosts).toFixed(2))

            //4º Interés del préstamo
            if(financeOption == "No"){
                economicDataMod.dataPerYear[i].loanInterests = 0
            }else{

                //estamos en el año 1
                if(i==0){
                    capitalPendiente = economicDataMod.initialInvestment
                }else{
                    //el 1º capitalPendiente es el nuevo (después de la reasignación); el 12º capitalPendiente es el antiguo (antes de la reasignación)
                    capitalPendiente = capitalPendiente - amortizacion
                }
                intereses = capitalPendiente * (economicDataMod.nominalInterest/100)
                amortizacion = cuota - intereses

                economicDataMod.dataPerYear[i].loanInterests = Number((-(intereses)).toFixed(2))
            }

            //5º Costes de paralización (sólo aplica el 1º año)
            if(i==0){
                economicDataMod.dataPerYear[i].paralizationCost = Number((economicDataMod.paralizationDays * economicDataMod.dailyIncome).toFixed(2))
            }else{
                economicDataMod.dataPerYear[i].paralizationCost = 0
            }

            //6º Rentabilidad anual
            let numerador = 0
            let denominador = 0
            if(i==0){
                numerador = economicDataMod.dataPerYear[i].annualFuelCost + economicDataMod.dataPerYear[i].variationVariousCosts - economicDataMod.dataPerYear[i].paralizationCost
            }else{
                numerador = economicDataMod.dataPerYear[i].annualFuelCost + economicDataMod.dataPerYear[i].variationVariousCosts
            }
            denominador = Math.pow(1 + (economicDataMod.annualDiscountRate/100), i+1)
            economicDataMod.dataPerYear[i].annualProfitability = Number((numerador / denominador).toFixed(2))

            //7º VAN
            if(i==0){
                economicDataMod.dataPerYear[i].van = 0
                //el valor inicial de casilla (en el año 1)  es los intereses + rentabilidad
                casilla = intereses + economicDataMod.dataPerYear[i].annualProfitability
            }else{ 

                //aquí, casilla es el valor del año anterior
                const aux = (intereses + economicDataMod.dataPerYear[i].annualProfitability) + casilla
                economicDataMod.dataPerYear[i].van = Number((aux - economicDataMod.initialInvestment).toFixed(2))
                //reasignamos el valor de 'casilla' para el siguiente año
                casilla = aux
            }

        }

       return economicDataMod
    }
}

export default NeobuqEconomicService